import { useState, type ReactNode } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { cn } from '@/utils/cn';

export function SpAdGroupSection({
  title,
  optional,
  children,
  collapsible = false,
  defaultOpen = true,
}: {
  title: string;
  optional?: boolean;
  children: ReactNode;
  collapsible?: boolean;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const showBody = !collapsible || open;

  return (
    <section className="border border-border rounded-xl bg-surface p-4 space-y-3">
      {collapsible ? (
        <button
          type="button"
          className="flex w-full items-center gap-2 text-left"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
        >
          {open ? (
            <ChevronDown className="w-4 h-4 text-foreground-muted shrink-0" />
          ) : (
            <ChevronRight className="w-4 h-4 text-foreground-muted shrink-0" />
          )}
          <span className="text-sm font-medium text-foreground">{title}</span>
          {optional ? (
            <span className="text-xs font-normal text-foreground-subtle">optional</span>
          ) : null}
        </button>
      ) : (
        <h2 className="text-sm font-medium text-foreground">
          {title}
          {optional ? (
            <span className="ml-2 text-xs font-normal text-foreground-subtle">optional</span>
          ) : null}
        </h2>
      )}
      {showBody ? <div className={cn(collapsible && 'pt-1')}>{children}</div> : null}
    </section>
  );
}
